(function () {
    angular.module('annualCycleModule', ['ui.bootstrap', 'ui.router']).run(['$location', '$state', function ($location, $state) {
        window.addEventListener("message", (event) => {
            if (!event.data || event.data.moduleName != 'annualCycle' || !event.data.eventName)
                return;
            let backendRoute = '';
            switch (event.data.eventName) {
                case 'annual-cycle-route-change':
                    let frontendRoute = event.data.value.toLowerCase();
                    if (frontendRoute.indexOf('activity/') > -1) { 
                        let activityId = frontendRoute.substring(frontendRoute.lastIndexOf('/') + 1);
                        if (activityId && activityId != '') {
                            backendRoute = 'ac/activity/' + activityId; 
                        }
                    } else if (frontendRoute.indexOf('task/') > -1) { 
                        let taskId = frontendRoute.substring(frontendRoute.lastIndexOf('/') + 1);
                        if (taskId && taskId != '') {
                            backendRoute = 'ac/task/' + taskId; 
                        }
                    }
                    else if (frontendRoute == '/home') {
                        backendRoute = 'ac/home';
                    }
                    break;
                default:
                    backendRoute = '/';
                    break;
            }

            if (!backendRoute) return;

            if (!history.state || !history.state.id || (history.state.id !== backendRoute)) {
                history.pushState({ id: backendRoute }, backendRoute, backendRoute);
            }
        });
    }]);
})();